// src/pages/CourseTime/components/slides/layouts/SubtitleSlide.comp.jsx
import React from 'react';
import * as S from '../../../styles';
import SlideTitleSpoken from '../common/SlideTitleSpoken.comp';
import { useSlideContentRenderer } from '../../../hooks/useSlideContentRenderer';

// Layout: TEMPLATE_WITH_SUBTITLE
const SubtitleSlide = ({ slide, renderSpokenText, skipTitleSpeech }) => {
  const { renderContent } = useSlideContentRenderer({ renderSpokenText, skipTitleSpeech });

  return (
    <S.SlideDescription>
      <S.SlideTitle>
        <SlideTitleSpoken slide={slide} skipTitleSpeech={skipTitleSpeech} renderSpokenText={renderSpokenText} />
      </S.SlideTitle>
      {Array.isArray(slide.SlideContent) && slide.SlideContent.map((item, idx) => (
        <S.SlidePoint key={idx}>
          <S.PointText>
            {item.SubTitle && (
              <>
                <strong>{item.SubTitle.trim()}:</strong>{' '}
              </>
            )}
            {item.Text && renderContent(`content_${idx}_text`, item.Text)}
          </S.PointText>
        </S.SlidePoint>
      ))}
    </S.SlideDescription>
  );
};

export default SubtitleSlide;
